import { AccordionBody, AccordionHeader, AccordionItem } from "../../Accordion";
import RadioCard from "../../RadioCard";
import ValidatedField from "../../form/ValidatedField";
import {
  RevisorsSectionProps,
  scrollToRefIfNotInView,
} from "../RevisorsErklaering";

export default function RevisorsHandling6(props: RevisorsSectionProps) {
  const { locked, isCompleteHelpers, formikProps, refs, texts } = props;
  const { revisors_handling_6 } = texts;
  const { values, errors, touched } = formikProps;
  return (
    <AccordionItem value="Handling6">
      <AccordionHeader
        sectionStarted={!!values.revisors_handling_6_question}
        sectionComplete={isCompleteHelpers.revisors_handling_6_complete}
        ref={refs.handling_6_ref}
        onClick={() => {
          scrollToRefIfNotInView(refs.handling_5_ref);
        }}
      >
        {revisors_handling_6.title}
      </AccordionHeader>
      <AccordionBody>
        <fieldset disabled={locked}>
          <legend className="h5 fw-normal mb-4 lh-base">
            {revisors_handling_6.description}
          </legend>
          <div className="vstack gap-3" role="group">
            <RadioCard
              name={revisors_handling_6.revisors_handling_6_question.id}
              value={
                revisors_handling_6.revisors_handling_6_question
                  .revisors_handling_6_question_alt_1.value
              }
              id={
                revisors_handling_6.revisors_handling_6_question
                  .revisors_handling_6_question_alt_1.value
              }
              text={
                revisors_handling_6.revisors_handling_6_question
                  .revisors_handling_6_question_alt_1.label
              }
            ></RadioCard>
            <RadioCard
              name={revisors_handling_6.revisors_handling_6_question.id}
              value={
                revisors_handling_6.revisors_handling_6_question
                  .revisors_handling_6_question_alt_2.value
              }
              id={
                revisors_handling_6.revisors_handling_6_question
                  .revisors_handling_6_question_alt_2.value
              }
              text={
                revisors_handling_6.revisors_handling_6_question
                  .revisors_handling_6_question_alt_2.label
              }
            >
              <label
                htmlFor={
                  revisors_handling_6.revisors_handling_6_alt_2_dato_reguleret
                    .id
                }
                className="mb-1"
              >
                {
                  revisors_handling_6.revisors_handling_6_alt_2_dato_reguleret
                    .label
                }
              </label>
              <div className="position-relative w-50 mb-4">
                <ValidatedField
                  touched={touched.revisors_handling_6_alt_2_dato_reguleret}
                  error={errors.revisors_handling_6_alt_2_dato_reguleret}
                  type="date"
                  name={
                    revisors_handling_6.revisors_handling_6_alt_2_dato_reguleret
                      .id
                  }
                  id={
                    revisors_handling_6.revisors_handling_6_alt_2_dato_reguleret
                      .id
                  }
                />
              </div>
              <label
                className="mb-1"
                htmlFor={
                  revisors_handling_6.revisors_handling_6_alt_2_forklaring.id
                }
              >
                {revisors_handling_6.revisors_handling_6_alt_2_forklaring.label}
              </label>
              <ValidatedField
                touched={touched.revisors_handling_6_alt_2_forklaring}
                error={errors.revisors_handling_6_alt_2_forklaring}
                autoComplete="off"
                as="textarea"
                id={revisors_handling_6.revisors_handling_6_alt_2_forklaring.id}
                name={
                  revisors_handling_6.revisors_handling_6_alt_2_forklaring.id
                }
                placeholder="Beskrivelse"
                rows={2}
              />
            </RadioCard>
            <RadioCard
              name={revisors_handling_6.revisors_handling_6_question.id}
              value={
                revisors_handling_6.revisors_handling_6_question
                  .revisors_handling_6_question_alt_3.value
              }
              id={
                revisors_handling_6.revisors_handling_6_question
                  .revisors_handling_6_question_alt_3.value
              }
              text={
                revisors_handling_6.revisors_handling_6_question
                  .revisors_handling_6_question_alt_3.label
              }
            >
              <label
                className="mb-1"
                htmlFor={
                  revisors_handling_6.revisors_handling_6_alt_3_uddybning.id
                }
              >
                {revisors_handling_6.revisors_handling_6_alt_3_uddybning.label}
              </label>
              <ValidatedField
                touched={touched.revisors_handling_6_alt_3_uddybning}
                error={errors.revisors_handling_6_alt_3_uddybning}
                autoComplete="off"
                as="textarea"
                id={revisors_handling_6.revisors_handling_6_alt_3_uddybning.id}
                name={
                  revisors_handling_6.revisors_handling_6_alt_3_uddybning.id
                }
                placeholder="Uddybning"
                rows={2}
              />
            </RadioCard>
          </div>
        </fieldset>
      </AccordionBody>
    </AccordionItem>
  );
}
